<template>
    <v-card fill-height :flat="flat" style="max-height:300px;width:100%;">
        <v-card-title style="height:15%;width:100%;padding-top:5px;padding-bottom:5px;">
            <v-layout row>
                <v-flex d-flex md6 class="title" style="padding-top:5px;padding-bottom:5px;align-items:center;">{{title}}</v-flex>
                <v-flex d-flex md6>
                    <v-select v-model="select" :items="dropDownList" flat style="height:100%; max-width:200px; font-size:18px; padding:0px;" />
                </v-flex>
            </v-layout>
        </v-card-title>
        <v-card-actions  ref="chartContainer"  fill-height style="height:200px;width:100%;padding-top:0px;padding-bottom:0px;">
            <highcharts v-if="load" style="height:100%;width:100%;" :options="optionsFinalized"></highcharts>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import More from 'highcharts/highcharts-more'
    import Highcharts from 'highcharts'
    import Exporting from 'highcharts/modules/exporting'

    Exporting(Highcharts);
    More(Highcharts);

    export default {
        name: "DropDownChart",
        components: {
             highcharts: Chart
        },
        props: {
            active:Boolean,
            title:String,
            flat:Boolean,
            chartOptions:Object||{},
            dropDownList:Array
        },
        data: function () {
            return {
                selectedChart:{},
                select:'',
                load:false,
            }
        },
        computed: {
            optionsFinalized : function () {
                var tmp = this.selectedChart;

                tmp.credits = false;
                return tmp;
            }
        },
        methods: {
            onResize(event) {
                setTimeout(() => {
                    if (typeof this.$refs['chartContainer'] != 'undefined') {
                        this.selectedChart.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load=true;
                    }
                });
            },
        },
        created() {
            window.addEventListener('resize', this.onResize);
        },
        mounted() {
            setTimeout(() => {
                this.select = this.dropDownList[0];

                if (!! this.chartOptions && !! this.chartOptions.chart && typeof this.$refs['chartContainer'] != 'undefined') {
                    this.chartOptions.chart.height = this.$refs['chartContainer'].clientHeight;
                    this.load = true;
                }
            });
        },
        watch: {
            select: function() {
                this.selectedChart = this.chartOptions[this.select];

                setTimeout(() => {
                    if (typeof this.selectedChart != 'undefined' && typeof this.$refs != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
                        this.selectedChart.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load=true;
                    }
                });
            },
            active : function() {
                setTimeout(() => {
                    if (typeof this.selectedChart != 'undefined' && typeof this.$refs != 'undefined' && typeof this.$refs['chartContainer'] != 'undefined') {
                        this.selectedChart.chart.height = this.$refs['chartContainer'].clientHeight;
                        this.load=true;
                    }
                });
            }
        }
    }
</script>

<style scoped>
</style>
